/**
 * LabelingIcon/index.js
 * desc: labeling feature main navigation icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const LabelingIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="labeling icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.labeling.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10.41.58l9 9c.36.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-7 7c-.36.37-.86.59-1.41.59-.55 0-1.05-.22-1.41-.58l-9-9C.22 10.05 0 9.55 0 9V2C0 .9.9 0 2 0h7c.55 0 1.05.22 1.41.58zM2 3.5C2 4.33 2.67 5 3.5 5S5 4.33 5 3.5 4.33 2 3.5 2 2 2.67 2 3.5z"/></svg>
    </IconButton>
);


export default LabelingIcon;
